import { Logger } from "@nestjs/common";
import { EntityRepository, Repository } from "typeorm";
import { ConfigEntity } from "../models/config.entity";

@EntityRepository(ConfigEntity)
export class ConfigRepository extends Repository<ConfigEntity> {

    async init() {
        // Check if config record exist, create default if not.
        const count = await this.count();
        if(count == 0) {
            this.insert({});
            Logger.log('Default config has created', 'ConfigRepository');
        }
    }

    async getConfiguration(): Promise<ConfigEntity> {
        return <ConfigEntity>await this.createQueryBuilder()
            .orderBy("id", "DESC")
            .getOne();
    }


    


}